import BestBuyLogo from '@/../public/static/logos/best-buy.webp';
import VertextLogo from '@/../public/static/logos/vertex.webp';
import ToyotaLogo from '@/../public/static/logos/toyota.webp';
import SharpLogo from '@/../public/static/logos/sharp.webp';
import Akamai from '@/../public/static/logos/akamai.webp';
import PAndGLogo from '@/../public/static/logos/pandg.webp';
import TripAdvisorLogo from '@/../public/static/logos/tripadvisor.webp';
import GrandThoronLogo from '@/../public/static/logos/grant-thorton.webp';
import { EmployerLogo } from '../types/types';

export const EMPLOYER_LOGOS: EmployerLogo[] = [
  {
    name: 'Best Buy',
    logo: BestBuyLogo.src,
    width: '60px',
    height: '38px',
  },
  {
    name: 'Vertex',
    logo: VertextLogo.src,
    width: '72px',
    height: '38px',
  },
  {
    name: 'Toyota',
    logo: ToyotaLogo.src,
    width: '130px',
    height: '21px',
  },
  {
    name: 'Akamai',
    logo: Akamai.src,
    width: '85px',
    height: '34px',
  },
  {
    name: 'Sharp',
    logo: SharpLogo.src,
    width: '74px',
    height: '23px',
  },
  {
    name: 'P&G',
    logo: PAndGLogo.src,
    width: '52px',
    height: '24px',
  },
  {
    name: 'TripAdvisor',
    logo: TripAdvisorLogo.src,
    width: '91px',
    height: '42px',
  },
  {
    name: 'Grand Thorton',
    logo: GrandThoronLogo.src,
    width: '126px',
    height: '25px',
  },
];
